import { Equipment } from './equipment';
import { Car } from "./car";

export class CarEquipment {

    constructor(_car: Car, _equipment: Equipment) {
        this.carId = _car.id;
        this.equipment = _equipment;
        this.equipmentId = _equipment.id;
        this.isPrincipal = false;
        this.isOption = false;
        this.equipmentCode = _equipment.code;
        this.equipmentName = _equipment.name;
        this.categoryName = _equipment.categoryName;
    }

    id: number;
    carId: number;
    car: Car;
    equipmentId: number;
    equipment: Equipment;
    isPrincipal: boolean;
    isOption: boolean;
    equipmentName: string;
    equipmentCode: string;
    categoryName: string;
}